var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HomeHeader'),_c('AboutUs'),_c('ServicesStairs'),_c('span',{staticClass:"hidden-xs-only"},[_c('ReinforcingStatement')],1),_c('Allies'),_c('Customers'),_c('ContactForm'),_c('Map')],1)}
var staticRenderFns = []

export { render, staticRenderFns }